import { withStyles } from '@material-ui/core';

import FallbackModal from './FallbackModal';
import { styles } from './FallbackModal.styles';

const FallbackModalContainer = withStyles(styles)(FallbackModal);

export default FallbackModalContainer;
